import React, { Component } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import { changePwdAction } from 'actions/adminActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {Modal} from "react-bootstrap";

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  Input,
  InputGroupText,
  InputGroup,
  Button
} from "reactstrap";

class AdminChangePwd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false,
      show: false,
      isSuccess: false,
      modalOKEnabled: false
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    document.title = 'Change Password';
    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/changePwd';
    }
  }

  componentWillUnmount() {
    if(this.props.response && 
      this.props.response.admin &&
        this.props.response.admin.response)
      delete this.props.response.admin.response;
  }

  setShow(bool) {
    this.setState({ show: bool });
  }
  handleClose = () => { 
    this.setShow(false);
    if(this.state.isSuccess){
      delete this.props.response.login.response;
      this.props.response.login.adminId = '';
      this.props.response.login.adminName = '';
      this.props.response.login.isSignedIn = false;
      this.props.response.login.isSuperAdmin = false;
      this.props.response.login.isStateAdmin = false;
      this.props.response.login.redirectAfterSignInTo = undefined;
      this.props.response.login.userToken= '';
      this.props.response.login.roles= [];

      this.props.navigate('/liquidlove/login');
    }
  };
  
  handleShow = () => { this.setShow(true) };

  render() {
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }

    let message;

    if (this.props.response.admin && this.props.response.admin.hasOwnProperty('response')){
      this.state.modalOKEnabled = true;
      if(this.props.response.admin.response.hasOwnProperty('status'))
        if(this.props.response.admin.response.status === 'success')
          this.state.isSuccess = true;
        else if(this.props.response.admin.response.status === 'error'){
          this.state.isSuccess = false;
          message = this.props.response.admin.response.message ? 
          this.props.response.admin.response.message
          : 'Sairam! Change Password is NOT successful';
        }
        else if(this.props.response.admin.response.status === 400){
          this.state.isSuccess = false;
          message = 'Sairam! Change Password is NOT successful';
        }
    }

    if(this.state.isSuccess)
      message = 'Sairam! Password change successful. Please login with your new password.';
    
    return (      
      <Formik
            initialValues={{
              oldPassword: '',
              newPassword: '',
              confirmPassword: ''
            }}
            validationSchema={Yup.object().shape({
              oldPwd: Yup.string()
                .required('Provide your present password'),
              newPwd: Yup.string()                
                .required('Provide your new password')
                .test('len', 'Password must be minimum 6 characters', val => val && val.toString().length >= 6 ),
              confirmPwd: Yup.string()                
                .required('Confirm new password'),
            })}
        onSubmit={fields => {
            let username = this.props.response.login.adminName;
            let oldPassword = fields.oldPwd;
            let newPassword = fields.newPwd;
            let confirmPassword = fields.confirmPwd;
            let token = this.props.response.login.userToken;
            const data = {
              username, oldPassword, newPassword, confirmPassword
            }

            const payload = {
              token, data
            }
            this.handleShow();
            this.props.dispatch(changePwdAction(payload));
        }  
      }
        render={({ errors, status, touched }) => (                    
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Change Password                            
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                      {message}
                      <Form>
                        <Modal
                          centered
                          show={this.state.show}
                          onHide={this.handleClose}
                          backdrop="static"
                          keyboard={false}
                          >
                            <Modal.Body>
                              {message ? message : 'Sairam! Processing your request.'}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                                OK
                              </Button>
                            </Modal.Footer>
                        </Modal>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        old Password
                      </InputGroupText>
                    <Field name="oldPwd" type="password" className={'form-control' + (errors.oldPwd && touched.oldPwd ? ' is-invalid' : '')} />
                    <ErrorMessage name="oldPwd" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        New Password
                      </InputGroupText>
                    <Field name="newPwd" type="password" className={'form-control' + (errors.newPwd && touched.newPwd ? ' is-invalid' : '')} />
                    <ErrorMessage name="newPwd" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Confirm Password
                      </InputGroupText>
                    <Field name="confirmPwd" type="password" className={'form-control' + (errors.confirmPwd && touched.confirmPwd ? ' is-invalid' : '')} />
                    <ErrorMessage name="confirmPwd" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <div className="col text-center">
                  <button type="submit" size="lg" outline className="btn btn-primary">Change Password</button>
                  </div>
                      </Form>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <AdminChangePwd navigate={navigate} {...props} />
});